import { Suspense, lazy } from "react";

const Page = lazy(() => import("./AssistPage").then((m) => ({ default: m.AssistPage })));

// A tab of the Organization page: the model that drafts a project from a
// description, and the record of what was sent to it.
export const assistTab = {
  key: "ai",
  label: "Compute and AI",
  path: "/ai",
  component: (props) => (
    <Suspense fallback={null}>
      <Page {...props} />
    </Suspense>
  ),
  when: "admin",
  after: "review",
  replaces: "compute",
};

const PlatformAi = lazy(() => import("./PlatformAiPage").then((m) => ({ default: m.PlatformAiPage })));

// A tab of the Platform page: the models we offer for drafting, what they
// cost us and what they are sold for.
export const platformAiTab = {
  key: "ai",
  label: "Compute and AI",
  path: "/platform/ai",
  after: "money",
  component: (props) => (
    <Suspense fallback={null}>
      <PlatformAi {...props} />
    </Suspense>
  ),
};

const Panel = lazy(() => import("./DraftPanel").then((m) => ({ default: m.DraftPanel })));

// The panel at the top of the New Project wizard.
export const assistWizardPanel = {
  key: "assist-draft",
  // It stands in for the step's own boxes until there is a draft to look
  // over: one box, not a form.
  covers: true,
  component: (props) => (
    <Suspense fallback={null}>
      <Panel {...props} />
    </Suspense>
  ),
};
